export default __webpack_public_path__ + "static/media/register-img.8c6e24d9.png";